export const matchTypeValues = ['exclude', 'include'] as const

export type MatchType = (typeof matchTypeValues)[number]
